import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getLocations as getLocationsApi,
  getTrackingDebugLogs,
} from "../../services/firebase-db.service";

import type { Location } from "../../types";

export interface LocationsState {
  locations: Array<Location>;
  locationsLoading: boolean;
  latestLocations: Array<Location>;
  latestLocationsLoading: boolean;
}

const initialState: LocationsState = {
  locations: [],
  locationsLoading: false,
  latestLocations: [],
  latestLocationsLoading: false,
};

type WatchPositionData = {
  timestamp: string;
  coords: {
    ellipsoidal_altitude: number;
    altitude: number;
    altitude_accuracy: number;
    heading_accuracy: number;
    heading: number;
    speed: number;
    accuracy: number;
    longitude: number;
    speed_accuracy: number;
    latitude: number;
  };
  is_moving: boolean;
  odometer: number;
};

const date = new Date();
date.setHours(date.getHours() - 6);
date.setDate(date.getDate() - 1);

export const getBusAttendanceLocations = createAsyncThunk(
  "locations/getBusAttendanceLocations",
  async (busAttendanceId: string) => {
    const response = await getTrackingDebugLogs();
    const watchPositionItems = response.filter(
      (i) => i.type === "watchPosition" && new Date(i.createdAt) > date
    );
    return watchPositionItems.map((item) => {
      const data = item.data as WatchPositionData;
      const locationItem: Location = {
        id: item.id,
        busAttendanceId: "1517",
        lat: data.coords.latitude,
        lng: data.coords.longitude,
        timestamp: new Date(data.timestamp).getTime(),
        accuracy: data.coords.accuracy,
      };

      return locationItem;
    });
    // getLocationsApi({ busAttendanceId });
  }
);

const threeDayMilliseconds = 3 * 24 * 60 * 60 * 1000;

export const getLatestLocation = createAsyncThunk(
  "locations/getLatestLocation",
  (busAttendanceIds: Array<string>) => {
    return getLocationsApi({
      busAttendanceIds,
      sort: { timestamp: "desc" },
      timestamp: { ">=": Date.now() - threeDayMilliseconds },
    });
  }
);

export const locationsSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBusAttendanceLocations.pending, (state) => {
        state.locationsLoading = true;
      })
      .addCase(getBusAttendanceLocations.fulfilled, (state, action) => {
        state.locationsLoading = false;
        state.locations = action.payload;
      })
      .addCase(getBusAttendanceLocations.rejected, (state) => {
        state.locationsLoading = false;
        state.locations = [];
      })
      .addCase(getLatestLocation.pending, (state) => {
        state.latestLocationsLoading = true;
      })
      .addCase(getLatestLocation.fulfilled, (state, action) => {
        state.latestLocationsLoading = false;
        state.latestLocations = Object.values(
          action.payload.reduce((acc, item) => {
            if (
              !acc[item.busAttendanceId] ||
              acc[item.busAttendanceId].timestamp < item.timestamp
            ) {
              acc[item.busAttendanceId] = item;
            }
            return acc;
          }, {} as Record<string, Location>)
        );
      })
      .addCase(getLatestLocation.rejected, (state, action) => {
        state.latestLocationsLoading = false;
        state.latestLocations = [];
      });
  },
});

// export const {} = locationsSlice.actions;

export default locationsSlice.reducer;
